module.exports = __webpack_public_path__ + "static/media/email-pink.8c044b91.svg";